// Learning Levels Translations Service
import learningLevelsData from '../data/learningLevels.json';

// In-memory storage for translations
let learningLevelsTranslations = { ...learningLevelsData };

/**
 * Get translation for a learning level name
 * @param {string} arabicName - The Arabic name of the learning level
 * @returns {object|null} Translation object with ar, fr, en properties
 */
export const getLearningLevelTranslation = (arabicName) => {
  return learningLevelsTranslations[arabicName] || null;
};

/**
 * Add a new learning level translation
 * @param {string} arabicName - The Arabic name
 * @param {string} arabicTranslation - The Arabic translation
 * @param {string} frenchTranslation - The French translation
 * @param {string} englishTranslation - The English translation
 */
export const addLearningLevelTranslation = (arabicName, arabicTranslation, frenchTranslation, englishTranslation) => {
  learningLevelsTranslations[arabicName] = {
    ar: arabicTranslation,
    fr: frenchTranslation,
    en: englishTranslation
  };
};

/**
 * Update an existing learning level translation
 * @param {string} arabicName - The Arabic name
 * @param {string} arabicTranslation - The new Arabic translation
 * @param {string} frenchTranslation - The new French translation
 * @param {string} englishTranslation - The new English translation
 */
export const updateLearningLevelTranslation = (arabicName, arabicTranslation, frenchTranslation, englishTranslation) => {
  if (learningLevelsTranslations[arabicName]) {
    learningLevelsTranslations[arabicName] = {
      ar: arabicTranslation,
      fr: frenchTranslation,
      en: englishTranslation
    };
    return true;
  }
  return false;
};

/**
 * Delete a learning level translation
 * @param {string} arabicName - The Arabic name
 */
export const deleteLearningLevelTranslation = (arabicName) => {
  if (learningLevelsTranslations[arabicName]) {
    delete learningLevelsTranslations[arabicName];
    return true;
  }
  return false;
};

/**
 * Get all learning level translations
 * @returns {object} All translations
 */
export const getAllLearningLevelTranslations = () => {
  return { ...learningLevelsTranslations };
};

/**
 * Reload translations from the JSON file
 */
export const reloadTranslations = () => {
  learningLevelsTranslations = { ...learningLevelsData };
};

/**
 * Save translations to a file (for export)
 */
export const saveTranslationsToFile = () => {
  const dataStr = JSON.stringify(learningLevelsTranslations, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'learningLevels-translations.json';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Validate translations file structure
 * @param {object} data - The data to validate
 * @returns {boolean} True if valid
 */
export const validateTranslationsFile = (data) => {
  if (!data || typeof data !== 'object') return false;
  
  for (const key in data) {
    const translation = data[key];
    if (!translation.ar || !translation.fr || !translation.en) {
      return false;
    }
  }
  
  return true;
};

const learningLevelsTranslationsService = {
  getLearningLevelTranslation,
  addLearningLevelTranslation,
  updateLearningLevelTranslation,
  deleteLearningLevelTranslation,
  getAllLearningLevelTranslations,
  reloadTranslations,
  saveTranslationsToFile,
  validateTranslationsFile
};

export default learningLevelsTranslationsService;

